export default "__VITE_ASSET__DjIDEoSG__"